<template>
    <div class="imgBox min-w-1400">
      <div class="imgBox1 min-w-1400">
        <div class="img1 max-w-1400">
          <p class="imgItem1">Chính sách bảo hành</p>
          <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
        </div>
      </div>
      <div class="imgBox2 min-w-1400">
        <div class="img2 max-w-1400">
          <!-- <h1>Cam kết bảo mật</h1> -->
          <!-- <div class="title-line"></div> -->
          <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";
  
  export default {
    data() {
      return {
        altText: "protocolTitle",
        // importedImg1: importedImg1,
        text: `1. Bảo hành nhỏ

– Phạm vi bảo hành sản phẩm: sửa chữa miễn phí các lỗi, sự cố kỹ thuật do lỗi của nhà sản xuất.

II. Bảo hành

Bảo hành

– Sản phẩm Easylife được bảo hành 90 ngày kể từ ngày giao hàng.

Điều kiện bảo hành

- Sản phẩm bị hư hỏng hoặc có vấn đề do lỗi của nhà sản xuất.

Sản phẩm vẫn còn trong thời gian bảo hành.

Những tình huống không được bảo hành

- Sản phẩm đã hết hạn

- Hư hỏng không phải do lỗi của nhà sản xuất mà do lỗi của người sử dụng, chẳng hạn như không tuân thủ hướng dẫn lắp đặt, sử dụng, bảo dưỡng của nhà sản xuất, sử dụng chức năng không đúng cách, không tuân thủ khuyến cáo. Báo cáo của nhà sản xuất...

- Hư hỏng do quá trình vận chuyển của người mua.

Thiệt hại do bất khả kháng như lũ lụt, bão, hỏa hoạn, động đất, v.v.

Chi phí bảo trì

– Mọi sản phẩm bị hư hỏng do lỗi của nhà sản xuất đều được bảo hành miễn phí.

– Đối với những hư hỏng sản phẩm không phải do lỗi của nhà sản xuất, công ty sẽ tính phí bảo hành, mức phí này được xác định theo thỏa thuận giữa công ty và khách hàng.



Quy trình bảo hành

Trong trường hợp bị hư hỏng, vui lòng làm theo các bước sau:

– Bước 1: Cung cấp cho công ty hoặc nhân viên bán hàng chịu trách nhiệm bán hàng cho khách hàng thông tin về sản phẩm bị hư hỏng, số tem sản phẩm và yêu cầu bảo hành.

– Bước 2: Công ty sẽ kiểm tra và xác minh lại dựa trên thông tin khách hàng cung cấp. Sau khi xác nhận thông tin, chúng tôi sẽ có trách nhiệm thông báo cho khách hàng về các lựa chọn bảo hành và thời hạn bảo hành.

– Bước 3: Công ty và khách hàng thống nhất về chế độ bảo hành và thời hạn bảo hành.

– Bước 4: Thực hiện dịch vụ bảo hành cho khách hàng theo đúng kế hoạch đã thỏa thuận.`,
      };
    },
    created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
  };
  </script>
  
  <style scoped>
  .imgBox {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
  }
  
  .imgBox1 {
    display: flex;
    justify-content: center;
    width: 100%;
    min-width: 1400px;
    background-color: "";
  }
  
  .imgBox2 {
    display: flex;
    justify-content: center;
    max-width: 1400px;
    padding-top: 40px;
    padding-bottom: 20px;
    height: 3700px;
    background-color: #ffffff;
    border-radius: 32px;
    margin: -140px auto 150px;
  }
  
  .imgBox3 {
    display: flex;
    justify-content: center;
    width: 100%;
    min-width: 1400px;
    background-color: "";
  }
  
  img {
    display: block;
  }
  
  .img1 {
    overflow: hidden;
    width: 100%;
  }
  
  .img2,
  .img4 {
    overflow: hidden;
  }
  
  .img3 {
    width: 100%;
    overflow: hidden;
    margin-left: 0;
    margin-right: 0;
  }
  
  .imgItem1 {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
  }
  
  .imgItem2 {
    max-width: 100%;
  }
  
  .imgItem3 {
    width: 100%;
    overflow: hidden;
    margin-left: 0;
    margin-right: 0;
  }
  
  h1 {
    margin-top: 50px;
    margin-left: 490px;
    color: #3f4842;
    font-size: 40px;
    /* border-bottom: 5px solid #04358A; */
    display: inline-block;
  }
  
  .textBox {
    margin-top: 50px;
    margin-left: 100px;
    margin-right: 100px;
    font-size: 18px;
    color: #333333;
  }
  
  .imgBox2 {
    transform: scale(90%);
    /* transform: scale(80%); */
    margin: -150px auto 100px;
    height: 1400px;
    /* box-shadow: 0 1px 4.8px 0px rgba(246, 102, 11, 0.25); */
    /* border: 2px solid #F6660B; */
  }
  .textBox {
    margin-top: 20px;
    margin-left: 50px;
    margin-right: 50px;
  }
  /* .imgBox2{
    border-radius: 0;
    border-top: 3px solid #7c2af8;
    border-left: 2px solid #e9e9e9;
    border-right: 2px solid #e9e9e9;
    border-bottom: 3px solid #c1c1c1;
  } */
  .title-line {
    width: 430px;
    /* background: url(./components/img/Group1.png); */
    /* background-repeat: no-repeat; */
    /* background-position: -150px 10px; */
    /* height: 50px; */
    /* border: 1px solid red; */
    border: 5px solid #0baf60;
    margin: 0 500px;
  }
  
  .img1 {
    /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
    height: 291px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .imgItem1 {
    color: #333333;
    font-family: "SF Pro Display";
    font-weight: 700;
    font-size: 52px;
    text-align: center;
  }
  </style>
  